import {useState} from 'react'

// mui
import {makeStyles} from '@material-ui/core/styles'

// custom components
import {Text, TextButton} from '../../../1elements'
import AccordionBase from '../../../2compounds/AccordionBase'

const ServiceListView = ({data, handleChange, servicesCategorizedByServiceType, selectedChecker}) => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(true)
    const {label, position} = data
    if(servicesCategorizedByServiceType[label] === undefined) return ''
    const key = `${label}${position}`
    const textButtonClassName = (id) => {
        return `${classes.serviceButton} ${selectedChecker(id)&&classes.selectedButton}`
    }

    return (
        <AccordionBase key={key} label={label} data={data} isOpen={isOpen} setIsOpen={setIsOpen}>
            {
                servicesCategorizedByServiceType[label]&&servicesCategorizedByServiceType[label].map((item, index)=>{
                    const {service_id, name} = item
                    const key = `${name}${index}`
                    return(
                        <TextButton key={key} variant={'text'} className={textButtonClassName(service_id)}
                                    clickHandler={()=>handleChange(item)}><Text type={'h3'}>{name}</Text></TextButton>
                )})
            }
        </AccordionBase>
    )
}

export default ServiceListView

const useStyles = makeStyles((theme)=>({
    accordion: {
        boxShadow: 'none !important'
    },
    accordionDetail: {
        display: 'flex',
        flexDirection: 'column'
    },
    serviceButton: {
        backgroundColor: `${theme.palette.quaternary.main} !important`,
        border: 'none !important',
        '& p': {
            color: `${theme.palette.primary.accent} !important`,
        }
    },
}))